/**
 * 44×44 account/sign-in glyph: outline ring plus person.
 *
 * The ring is part of the asset. Callers should not add a CSS border or the
 * control will show a double circle.
 */
export function AccountIcon() {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
            <path
                d="M22 0.5C33.8741 0.5 43.5 10.1259 43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5Z"
                stroke="var(--gm-foreground-fg-outline-primary, #D1D0CF)"
            />
            <path
                d="M14.5 28.6667C16.4465 26.6021 19.0892 25.3333 22 25.3333C24.9108 25.3333 27.5535 26.6021 29.5 28.6667M25.75 18.25C25.75 20.3211 24.0711 22 22 22C19.9289 22 18.25 20.3211 18.25 18.25C18.25 16.1789 19.9289 14.5 22 14.5C24.0711 14.5 25.75 16.1789 25.75 18.25Z"
                stroke="var(--gm-fg-primary-black, #1F1E1D)"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}
